import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation } from '@tanstack/react-query';
import { getErrorCode, getErrorStatusCode } from "../../../../../api/api-response";
import { RestEndpoints } from "../../../../../api/endpoints";
import { IProductData } from "../../../../../configurator/components/product/product-list/creatable-products-list.component";
import getInstance from "../../../../../utils/rest";
import { CfmCreateProductConverter } from "../../../models/converter/cfm-create-product.converter";

const createNewCfmProducts = async (config: IProductData[]): Promise<void> => {
  const convertedConfig = config.map(CfmCreateProductConverter.productDataToModel);
  await getInstance().post(RestEndpoints.CreateNewCfmProducts, { data: convertedConfig });
};

export const useCreateNewCfmProductsQuery = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: ({ config }: { config: IProductData[] }) => createNewCfmProducts(config),

    onError: (error) => {
      const errorMsg = getErrorCode(error);
      const errorCode = getErrorStatusCode(error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    },
  });
};
